import { countSearchParams, useOnMount } from '@prismamedia/one-components';
import { useEffect } from 'react';
import {
  ArrayParam,
  JsonParam,
  StringParam,
  useQueryParam,
} from 'use-query-params';
import { BrandKey } from '__generated__/queries-newsletter';
import {
  useGlobalBrandKey,
  useGlobalNewslettersFilter,
  useGlobalSearchParams,
} from './globalState';

export const useQueryParams = () => {
  const [brandKey, setBrandKey] = useGlobalBrandKey();
  const [searchParams, setSearchParams] = useGlobalSearchParams();
  const [
    newslettersFilter,
    setNewslettersFilter,
  ] = useGlobalNewslettersFilter();
  const [brandKeyUrl, setBrandKeyUrl] = useQueryParam('brand', StringParam);
  const [searchUrl, setSearchUrl] = useQueryParam('search', JsonParam);
  const [newslettersUrl, setNewslettersUrl] = useQueryParam(
    'newsletters',
    ArrayParam,
  );

  useOnMount(() => {
    brandKeyUrl && setBrandKey(brandKeyUrl as BrandKey);
    searchUrl && setSearchParams(searchUrl);
    newslettersUrl && setNewslettersFilter(newslettersUrl as string[]);
  });

  useEffect(() => {
    setBrandKeyUrl(brandKey, 'replaceIn');
  }, [brandKey, setBrandKeyUrl]);

  useEffect(() => {
    if (countSearchParams(searchParams)) {
      setSearchUrl(searchParams, 'replaceIn');
    } else {
      setSearchUrl(undefined);
    }
  }, [searchParams, setSearchUrl]);

  useEffect(() => {
    setNewslettersUrl(newslettersFilter, 'replaceIn');
  }, [newslettersFilter, setNewslettersUrl]);
};
